import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  IconButton,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { createMachinePhotosThunk } from "store/reducers/machine_func/machinePhotos";
import addURLPrefix from "utils/addURLPrefix";
import { useNavigate } from "react-router-dom";
import { FcAddImage } from "react-icons/fc";

const MachineCard = ({
  machine,
  handleContextMenu,
  handleClick,
  openAddMoreCabins,
  openAddMoreTrays,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const createMachinePhotosLoading = useSelector(
    (state) => state.vending.createMachinePhotosLoading
  );

  const { activateMachineLoading, deleteMachineLoading } = useSelector(
    (state) => state.vending
  );

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    maxFiles: 5,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
    },
  });
  useEffect(() => {
    if (acceptedFiles.length > 0) {
      acceptedFiles.forEach((file) => {
        dispatch(
          createMachinePhotosThunk({ photo: file, machine: machine.id })
        );
      });
    }
  }, [acceptedFiles, dispatch, machine.id]);

  useEffect(() => {
    if (createMachinePhotosLoading[machine.id]) {
      console.log("Loading", machine.id);
    }
  }, [createMachinePhotosLoading, machine.id]);

  const theme = useTheme();
  const bgColor = theme.palette.mode === "light" ? "grey.100" : "grey.700";

  return (
    <Card elevation={2} onContextMenu={(e) => handleContextMenu(e, machine)}>
      {machine.photos.length === 0 ? (
        <>
          {createMachinePhotosLoading[machine.id] ? (
            <Skeleton
              variant="rectangular"
              sx={{ height: 160 }}
              animation="wave"
            />
          ) : (
            <Box
              height={160}
              sx={{
                display: "flex",
                backgroundColor: bgColor,
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
              {...getRootProps({ className: "dropzone" })}
            >
              <input {...getInputProps()} />
              <Typography color="gray">Add few images</Typography>
              <FcAddImage size={30} />
            </Box>
          )}
        </>
      ) : (
        <CardMedia
          component="img"
          height={160}
          image={addURLPrefix(machine.photos[0].photo)}
          alt="VM image"
        />
      )}

      <CardHeader
        action={
          <IconButton
            aria-label="settings"
            onClick={(e) => handleClick(e, machine)}
          >
            <MoreVertIcon />
          </IconButton>
        }
        title={
          <Stack direction="row" alignItems="baseline">
            <Typography variant="h5">{machine.name}</Typography>
            <Typography
              marginLeft={1}
              color={machine.active ? "green" : "orange"}
            >
              {activateMachineLoading[machine.id] ||
              deleteMachineLoading[machine.id] ? (
                <Skeleton sx={{ width: 60 }} animation="wave" />
              ) : machine.active ? (
                "(Active)"
              ) : (
                "(Inactive)"
              )}
            </Typography>
          </Stack>
        }
        subheader={
          <Box sx={{ display: "flex", alignItems: "center",gap: 1 }}>
            <Typography color="gray" variant="subtitle2">
              @{machine.username}
            </Typography>
            <Typography color="gray" variant="body2">
              {new Date(machine.created_date).toDateString()}
            </Typography>
          </Box>
        }
        sx={{ flexGrow: 1, paddingY: 1.5 }}
      />

      <CardContent sx={{ paddingY: 0 }}>
        <Stack direction="row">
          <Typography>Current location : </Typography>
          <Typography marginLeft={1} color="blue">
            {machine.location ?? "Not assigned"}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row">
            <Typography>Total cabins : </Typography>
            <Typography marginLeft={1} color="blue">
              {machine.cabin_count}
            </Typography>
          </Stack>
          {/* <Button
            size="small"
            variant="text"
            endIcon={<AddIcon />}
            onClick={() => openAddMoreCabins(machine)}
          >
            Add more
          </Button> */}
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row">
            <Typography>Total trays : &nbsp; </Typography>
            <Typography marginLeft={1} color="blue">
              {machine.tray_count}
            </Typography>
          </Stack>
          {/* <Button
            size="small"
            variant="text"
            endIcon={<AddIcon />}
            onClick={() => openAddMoreTrays(machine)}
          >
            Add more
          </Button> */}
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row">
            <Typography>Current stock : </Typography>
            <Typography marginLeft={1} color="blue">
              {machine.stock_count} Nos ({machine.stock_percentage}%)
            </Typography>
          </Stack>
          {/* <Button size="small" variant="text" endIcon={<AutorenewIcon />}>
            Refill
          </Button> */}
        </Stack>
        <Typography
          color="gray"
          sx={{
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          Assigned payments
        </Typography>
        <Stack direction="row" alignItems="center" flexGrow={1} marginTop={1}>
          {machine.payments.map((payment) => (
            <Chip key={payment.id} label={payment.name} size="small" />
          ))}
          {machine.payments.length === 0 && (
            <Typography
              color="gray"
              sx={{
                flexGrow: 1,
                textAlign: "center",
                paddingY: "1px",
              }}
            >
              No payment assigned
            </Typography>
          )}
        </Stack>
      </CardContent>
      <CardActions sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          size="small"
          color="primary"
          onClick={() => {
            navigate(machine.id.toString());
          }}
        >
          View more
        </Button>
      </CardActions>
    </Card>
  );
};

export default MachineCard;
